import { Link, useNavigate } from "react-router-dom";
import { LogOut, KeyRound } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { useAuth } from "@/context/AuthContext";
import { Logo } from "@/components/Logo";
import { ChangePasswordDialog } from "@/components/ChangePasswordDialog";

export const AppHeader = () => {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  return (
    <header className="sticky top-0 z-40 bg-white/90 backdrop-blur-md border-b border-slate-200 px-4 sm:px-8 h-16 flex items-center justify-between">
      <Link to={user?.role === "admin" ? "/admin" : "/dashboard"} data-testid="header-home-link"><Logo /></Link>
      <div className="flex items-center gap-3">
        <div className="hidden sm:block text-right">
          <div className="text-sm font-medium text-slate-900" data-testid="header-user-name">{user?.name}</div>
          <div className="text-xs text-slate-500">{user?.email}</div>
        </div>
        <Badge variant="outline" className="font-mono uppercase text-[10px] tracking-wider" data-testid="header-role-badge">
          {user?.role === "admin" ? "Admin" : "Student"}
        </Badge>
        <ChangePasswordDialog trigger={
          <Button variant="ghost" size="sm" data-testid="header-change-password"
            className="hover:bg-slate-900 hover:text-white transition-colors">
            <KeyRound className="h-4 w-4 sm:mr-1.5" /><span className="hidden sm:inline">Password</span>
          </Button>
        } />
        <Button variant="ghost" size="sm" data-testid="logout-button"
          className="hover:bg-slate-900 hover:text-white transition-colors"
          onClick={() => { logout(); nav("/login"); }}>
          <LogOut className="h-4 w-4 sm:mr-1.5" /><span className="hidden sm:inline">Logout</span>
        </Button>
      </div>
    </header>
  );
};
